import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hideFloatingWidgets, showFloatingWidgets } from '../lib/floatingWidgets';

/**
 * El Asistente Web (el chatbot flotante de la izquierda, «Vende Chatbots como
 * este») SOLO en la home. Decisión del owner, 2026-10-02.
 *
 * El chatbot no lo monta React: lo inyecta el loader del core desde
 * public/index.html, que ya solo lo carga si la PRIMERA página es la home. Esto
 * cubre la navegación dentro de la web (el router no recarga el documento):
 *  - al llegar a la home, monta el loader si aún no estaba
 *    (`window.__invokeChatMount`, expuesto por index.html) y deja de ocultarlo;
 *  - en cualquier otra ruta, lo oculta (botón, panel y burbuja de reclamo), también si
 *    el loader (asíncrono) los añade o los abre después.
 *
 * Se oculta con `hideFloatingWidgets` (src/lib/floatingWidgets.js): una regla CSS, sin
 * tocar el `display` que gobierna el loader. Ver allí por qué.
 */
export const HOME_PATHS = ['/', '/home'];

export const isHomePath = (pathname) => {
  const p = String(pathname || '/').replace(/\/+$/, '') || '/';
  return HOME_PATHS.includes(p);
};

const REASON = 'route-not-home';

const WebAssistantHomeOnly = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isHomePath(pathname)) {
      showFloatingWidgets(REASON);
      if (typeof window.__invokeChatMount === 'function') window.__invokeChatMount();
    } else {
      hideFloatingWidgets(REASON);
    }
  }, [pathname]);

  return null;
};

export default WebAssistantHomeOnly;
